// extracted by mini-css-extract-plugin
export default {"bookmarkletButton":"bookmarklet-button__bookmarkletButton__NjiON"};